import {
  ProviderCaseStatusGetDTO,
  ProviderStatusAppliesTo,
} from "src/app/pages/providers/provider.model";

export const DEFAULT_PROVIDER_STATUS_APPLIES_TO: ProviderStatusAppliesTo = "case";

export function normalizeProviderStatusAppliesTo(
  appliesTo?: ProviderStatusAppliesTo,
): ProviderStatusAppliesTo {
  return appliesTo ?? DEFAULT_PROVIDER_STATUS_APPLIES_TO;
}

export function normalizeProviderCaseStatus(
  status: ProviderCaseStatusGetDTO,
): ProviderCaseStatusGetDTO {
  return {
    ...status,
    appliesTo: normalizeProviderStatusAppliesTo(status.appliesTo),
  };
}

export function normalizeProviderCaseStatuses(
  statuses: ProviderCaseStatusGetDTO[],
): ProviderCaseStatusGetDTO[] {
  return statuses.map(normalizeProviderCaseStatus);
}

export function filterProviderStatusesByAppliesTo(
  statuses: ProviderCaseStatusGetDTO[],
  appliesTo: ProviderStatusAppliesTo,
): ProviderCaseStatusGetDTO[] {
  return statuses.filter(
    (status) =>
      normalizeProviderStatusAppliesTo(status.appliesTo) === appliesTo,
  );
}

export function findProviderStatusByValue(
  statuses: ProviderCaseStatusGetDTO[],
  value: string,
  appliesTo?: ProviderStatusAppliesTo,
): ProviderCaseStatusGetDTO | undefined {
  const pool = appliesTo
    ? filterProviderStatusesByAppliesTo(statuses, appliesTo)
    : statuses;

  return pool.find((status) => status.value === value);
}
